<div class="container">
  <div class="container mt-5 text-center w-75 ">
    <h3  class="display-5 fw-light" style="color: var(--secondary-color);">¿Qué tipo de <span class="fw-bold">exámenes/ procedimientos </span>se debe realizar?</h3>
  </div>
  <div class="container w-75 mx-auto text-start">
    <ul style="list-style: none;" class=" row ">
      <li *ngFor="let listItem of listItems" class="mt-3 text-secondary col-6">
        <i style="color: var(--terciary-color); font-size: .7rem" class="bi bi-circle-fill"></i>
        {{ listItem.texto }}
      </li>
    </ul>
  </div>
</div>
